/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const CursorDefaultIconOutline = createIcon({
  displayName: 'CursorDefaultIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M14.623 13.402l2.083 4.116c.188.372.039.826-.333 1.014l-2.245 1.136c-.372.188-.826.039-1.014-.333l-2.083-4.116 -3.59 2.247 .008-12.46c0-.622.711-.977 1.208-.603l9.901 7.437 -3.935 1.562Z"
        strokeLinecap="round"
        strokeWidth="1.4441"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
      ></path>
      <path fill="none" d="M0 0h24v24h-24Z"></path>
    </>
  ),
})

const CursorDefault: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
    default:
      return <CustomIcon as={CursorDefaultIconOutline} {...props} />
  }
}

export default memo(CursorDefault)
